<div [formGroup]="parentGroup" class="border-area">
    <div formArrayName="subFieldConf">
        <h4 class="my-0 mb-2" style="font-weight:normal;">IconSelection-Konfiguration</h4>
        @for (opt of options.controls; track opt) {
            @if (getFormGroup(opt)) {
                <div [formGroup]="getFormGroup(opt)!" class="border-area">
                        <div class="option-row">

                            <mat-form-field>
                                <mat-label>Typ</mat-label>
                                <mat-select formControlName="name">
                                    @for (dt of nameOptions; track dt) {
                                        <mat-option [value]="dt">{{ dt }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <button mat-icon-button color="warn" (click)="removeSubField(options, $index)">
                                <mat-icon>delete</mat-icon>
                            </button>

                        </div>
                </div>
            }
        }

    </div>

    <button mat-raised-button color="primary" (click)="addSubField(parentGroup)">
        Option hinzufügen
    </button>
</div>
